var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5H6V19.5H3",
    stroke: "#C0C9FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.25H9C9.39782 14.25 9.77936 14.408 10.0607 14.6893C10.342 14.9706 10.5 15.3522 10.5 15.75H13.875C14.1734 15.75 14.4595 15.8685 14.6705 16.0795C14.8815 16.2905 15 16.5766 15 16.875C15 17.1734 14.8815 17.4595 14.6705 17.6705C14.4595 17.8815 14.1734 18 13.875 18H9.75",
    stroke: "#C0C9FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.7999L17.4863 15.2999C17.8264 15.0973 18.2153 14.991 18.6113 14.9924C18.896 14.9922 19.178 15.048 19.4412 15.1567C19.7043 15.2655 19.9435 15.425 20.145 15.6262L21 16.4999L14.2762 20.5349C13.7673 20.8392 13.1855 20.9999 12.5925 20.9999C12.2005 20.9996 11.8117 20.9285 11.445 20.7899L6 18.7499",
    stroke: "#C0C9FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 13.5C17.1495 13.5 19.5 11.1495 19.5 8.25C19.5 5.35051 17.1495 3 14.25 3C11.3505 3 9 5.35051 9 8.25C9 11.1495 11.3505 13.5 14.25 13.5Z",
    stroke: "#C0C9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6237 8.25003C13.3038 8.23251 13.0029 8.09311 12.7826 7.86049C12.5624 7.62788 12.4397 7.31973 12.4397 6.9994C12.4397 6.67908 12.5624 6.37093 12.7826 6.13831C13.0029 5.9057 13.3038 5.7663 13.6237 5.74878",
    stroke: "#C0C9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8762 8.25C15.1961 8.26752 15.497 8.40692 15.7173 8.63954C15.9375 8.87215 16.0602 9.1803 16.0602 9.50062C16.0602 9.82095 15.9375 10.1291 15.7173 10.3617C15.497 10.5943 15.1961 10.7337 14.8762 10.7513",
    stroke: "#C0C9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 4.5V5.74875",
    stroke: "#C0C9FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10.7512V12",
    stroke: "#C0C9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6238 8.25H14.8763",
    stroke: "#C0C9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 6.37503C16.125 6.37503 15.4988 5.74878 14.8763 5.74878H13.6238",
    stroke: "#C0C9FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 10.125C12.375 10.125 13.0013 10.7513 13.6238 10.7513H14.8762",
    stroke: "#C0C9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnIcon);
export default __webpack_public_path__ + "static/media/earnIcon.1068fb7185a3655ad41d694f3f3cd3b6.svg";
export { ForwardRef as ReactComponent };